import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";
import { useNavigate, useParams } from "react-router-dom";

const NewInvoice = () => {

  const navigate = useNavigate();
  const { id } = useParams();

  const [supplierList, setSupplierList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // yyyy-mm-dd
  };
  const [form, setForm] = useState({
    invoiceNo: "",
    invoiceDate: getTodayDate(),
    supplierId: "",
    currencyId: "",
    amount: "",
    amountInRs: ""
  });
  useEffect(() => {
    if (!id) {
      setForm(prev => ({
        ...prev,
        invoiceDate: getTodayDate()
      }));
    }
  }, []);
  useEffect(() => {
    loadDropdowns();

    if (id) {
      loadInvoice();
    }

  }, []);

  const loadDropdowns = async () => {

    const supplierRes = await axios.get("/invoices/suppliers");
    setSupplierList(supplierRes.data);

    const currencyRes = await axios.get("/invoices/currencies");
    setCurrencyList(currencyRes.data);

  };

  const loadInvoice = async () => {
    try {
      const res = await axios.get(`/invoices/${id}`);

      const data = res.data;

      setForm({
        invoiceNo: data.InvoiceNo,
        invoiceDate: data.InvoiceDate?.split("T")[0], // ✅ fix date
        supplierId: data.ShipperId,
        currencyId: data.Currency_Id,
        amount: data.Amount,
        amountInRs: data.AmountInRs
      });

    } catch (err) {
      console.error(err);
    }
  };

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });

  };

  const saveInvoice = async () => {
    try {
      if (id) {
        await axios.put(`/invoices/${id}`, form);
      } else {
        await axios.post("/invoices", form);
      }
      alert(id ? "Invoice updated successfully" : "Invoice saved successfully");
      navigate("/transaction/new-invoice/list");
    } catch (err) {
      alert(err.response?.data?.message || "Error saving invoice");
    }

  };

  return (

    <div className="container">

      <h3>{id ? "Edit Invoice" : "New Invoice"}</h3>

      <div className="card p-3">

        <div className="row">

          <div className="col-md-4">
            <label>Invoice No</label>
            <input
              className="form-control"
              name="invoiceNo"
              value={form.invoiceNo}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-4">
            <label>Invoice Date</label>
            <input
              type="date"
              className="form-control"
              name="invoiceDate"
              value={form.invoiceDate}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-4">
            <label>Supplier</label>
            <select
              className="form-control"
              name="supplierId"
              value={form.supplierId}
              onChange={handleChange}
            >
              <option value="">Select Supplier</option>

              {supplierList.map((s) => (
                <option key={s.ShipperId} value={s.ShipperId}>
                  {s.ShipperName}
                </option>
              ))}

            </select>
          </div>

        </div>

        <div className="row mt-3">

          <div className="col-md-4">
            <label>Currency</label>
            <select
              className="form-control"
              name="currencyId"
              value={form.currencyId}
              onChange={handleChange}
            >
              <option value="">Select Currency</option>

              {currencyList.map((c) => (
                <option key={c.Currency_Id} value={c.Currency_Id}>
                  {c.Code}
                </option>
              ))}

            </select>
          </div>

          <div className="col-md-4">
            <label>Amount</label>
            <input
              className="form-control"
              name="amount"
              value={form.amount}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-4">
            <label>Amount In Rs</label>
            <input
              className="form-control"
              name="amountInRs"
              value={form.amountInRs}
              onChange={handleChange}
            />
          </div>

        </div>

        <div className="mt-4">

          <button
            className="btn btn-success me-2"
            onClick={saveInvoice}
          >
            Save
          </button>

          <button
            className="btn btn-secondary"
            onClick={() => navigate("/transaction/new-invoice/list")}
          >
            Cancel
          </button>

        </div>

      </div>

    </div>
  );
};

export default NewInvoice;
